<template>
  <div class="download">
    <img
      v-if="wxshow"
      class="downts"
      src="../../../../assets/images/downts.png"
      alt=""
    />
    <img
      class="downTitle"
      src="../../../../assets/images/downTitle.png"
      alt=""
    />
  </div>
</template>
<script>
export default {
  data() {
    return {
      wxshow: false,
    };
  },
  props: {},
  created() {
    this.wx()
  },
  methods: {
    wx() {
      var ua = navigator.userAgent.toLowerCase();
      var isWeixin = ua.indexOf("micromessenger") != -1;
      if (!isWeixin) {
        window.location.href = "https://ouchn-opreate-web-pub.oss-cn-beijing.aliyuncs.com/%E5%BC%80%E6%94%BE%E4%BA%91%E4%B9%A6%E9%99%A23.1.2.16_20221102.apk";
      } else {
        this.wxshow = true;
      }
    },
  },
};
</script>

<style scoped lang='scss'>
.download {
  width: 100%;
  height: 100vh;
  background: url("../../../../assets/images/downbg.png") no-repeat;
  background-position: 100% 100%;
  background-size: cover;
  display: flex;
  flex-direction: column;
  .downts {
    position: absolute;
    right: 10px;
    width: 120px;
    height: 120px;
  }
  .downTitle {
    width: 330px;
    height: 330px;
    margin: 25vh auto;
  }
}
</style>
